import React, { useEffect, useState } from "react";
import { Input, Select, Flex } from "antd";
import { EditOutlined, SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { dispatch, useSelector } from "../../redux/store";
import Loading from "../../global/item/Loading/loading";
import TitleComponent from "../../global/Custom/TitleComponent/TitleComponent";
import { getFlower } from "../../redux/action/flower";
import { getGroup } from "../../redux/action/groups";
import ProductItem from "./ProductItem";

const { Option } = Select;

function ProductPage() {
  const { t } = useTranslation();
  const { flowerList } = useSelector((state) => state.flower);
  const { groupList } = useSelector((state) => state.group);

  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [debouncedSearchText, setDebouncedSearchText] = useState(""); // debounce state
  const [groupFilter, setGroupFilter] = useState<number | null>(null);

  // --- Debounce searchText ---
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchText);
    }, 300); // 300ms debounce

    return () => {
      clearTimeout(handler); // clear timeout nếu searchText thay đổi trước 300ms
    };
  }, [searchText]);

  // --- useEffect lần đầu: load group và product ---
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        await dispatch(getGroup());

        const params: { name?: string; groupId?: number } = {};
        if (debouncedSearchText.trim() !== "") params.name = debouncedSearchText.trim();
        if (groupFilter !== null) params.groupId = groupFilter;

        await dispatch(getFlower(params));
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [debouncedSearchText, groupFilter]); // chỉ chạy lần đầu

  // --- useEffect khi debounceSearchText hoặc groupFilter thay đổi ---
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const params: { name?: string; groupId?: number } = {};
        if (debouncedSearchText.trim() !== "") params.name = debouncedSearchText.trim();
        if (groupFilter !== null) params.groupId = groupFilter;

        await dispatch(getFlower(params));
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, [debouncedSearchText, groupFilter]);

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <TitleComponent
            title="Sản phẩm"
            type="primary"
            icon={<EditOutlined />}
            data={t("Tạo mới")}
            to="/Product/Data/Create"
          />

          <Flex
            align="center"
            justify="space-between"
            gap={12}
            style={{
             
              marginBottom: 20,
         
            }}
          >
            <Input
              placeholder="Tìm theo tên hoa..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 260 }}
            />
            <Flex align="center" gap={8}>
              <p>Danh mục:</p>
              <Select
                placeholder="Chọn danh mục"
                style={{ width: 220, height: 46 }}
                value={groupFilter ?? undefined}
                onChange={(value) => setGroupFilter(value ?? null)}
                allowClear
              >
                {groupList?.map((g) => (
                  <Option key={g.groupId} value={g.groupId}>
                    {g.groupName}
                  </Option>
                ))}
              </Select>
            </Flex>
          </Flex>

          <ProductItem flower={flowerList} />
        </div>
      )}
    </div>
  );
}

export default ProductPage;
